import Vue from 'vue'
import store from '@/store'
Vue.directive('drag', (el) => {
  el.style.bottom = '60px'
  el.style.right = '40px'
  let client = {}
  el.addEventListener('touchmove', (e) => {
    if (!client.clientY || !client.clientX) {
      client.clientY = e.touches[0].clientY
      client.clientX = e.touches[0].clientX
    }
    let nowClientY = e.touches[0].clientY - client.clientY - 8
    let nowClientX = e.touches[0].clientX - client.clientX - 8
    el.style.bottom = nowClientY > 0 ? (60 - nowClientY) + 'px' : (60 + Math.abs(nowClientY)) + 'px'
    el.style.right = nowClientX > 0 ? (40 - nowClientX) + 'px' : (40 + Math.abs(nowClientX)) + 'px'
  })
})
